export default __webpack_public_path__ + "static/box_b.2e8ed45229dd66d6e30c44740341629b.png";